const COMPONENT_NAME = "ProductCarouselUI";
const SKELETON_COMPONENT_NAME = "ProductCarouselUISkeleton";
const DEFAULT_MAX_SLIDES = 5;
export {
  COMPONENT_NAME,
  DEFAULT_MAX_SLIDES,
  SKELETON_COMPONENT_NAME
};
